import { render, staticRenderFns } from "./ListInbox.vue?vue&type=template&id=0663d155&"
import script from "./ListInbox.vue?vue&type=script&lang=js&"
export * from "./ListInbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports